import { MasterDashboard } from 'views/missioncontrol/dashboard';
import { MasterAccounts } from 'views/missioncontrol/accounts';
import { MasterUsers } from 'views/missioncontrol/users';
import { MasterFeedback } from 'views/missioncontrol/feedback';
import { MasterLogs } from 'views/missioncontrol/log/list';
import { MasterLogDetail } from 'views/missioncontrol/log/detail';
import { MasterEventGroups } from 'views/missioncontrol/event/groups';
import { MasterEventList } from 'views/missioncontrol/event/list';
import { MasterEventDetail } from 'views/missioncontrol/event/detail';

const Routes = [
  {
    path: '/missioncontrol/dashboard',
    view: MasterDashboard,
    layout: 'missioncontrol',
    permission: 'master',
    title: 'Mission Control',
  },
  {
    path: '/missioncontrol/accounts',
    view: MasterAccounts,
    layout: 'missioncontrol',
    permission: 'master',
    title: 'Accounts',
  },
  {
    path: '/missioncontrol/users',
    view: MasterUsers,
    layout: 'missioncontrol',
    permission: 'master',
    title: 'Users',
  },
  {
    path: '/missioncontrol/feedback',
    view: MasterFeedback,
    layout: 'missioncontrol',
    permission: 'master',
    title: 'User Feedback',
  },
  {
    path: '/missioncontrol/logs',
    view: MasterLogs,
    layout: 'missioncontrol',
    permission: 'master',
    title: 'App Logs',
  },
  {
    path: '/missioncontrol/logs/:id',
    view: MasterLogDetail,
    layout: 'missioncontrol',
    permission: 'master',
    title: 'Log Detail',
  },
  {
    path: '/missioncontrol/events',
    view: MasterEventGroups,
    layout: 'missioncontrol',
    permission: 'master',
    title: 'Events',
  },
  {
    path: '/missioncontrol/events/:group',
    view: MasterEventList,
    layout: 'missioncontrol',
    permission: 'master',
    title: 'Event',
  },
  {
    path: '/missioncontrol/events/:group/:id',
    view: MasterEventDetail,
    layout: 'missioncontrol',
    permission: 'master',
    title: 'Event Detail',
  },
];

export default Routes;
